<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "Calendly" });
import { Button } from "../../elements/index.js";
import { onMount } from "svelte";
export let url;
export let label = "";
export let css = "";
export let mode = "inline";
export let icon = "";
let calendlyElement;
const loadCalendlyScript = async () => {
    const SRC = "https://assets.calendly.com/assets/external/widget.js";
    return new Promise((resolve, reject) => {
        const SCRIPT = document.createElement("script");
        SCRIPT.src = SRC;
        SCRIPT.onload = () => {
            resolve();
        };
        SCRIPT.onerror = () => {
            reject(new Error("Request to Calendly script failed"));
        };
        document.body.appendChild(SCRIPT);
    });
};
onMount(async () => {
    if (!window.Calendly) {
        try {
            await loadCalendlyScript();
        }
        catch (error) {
            console.error("Error loading Calendly script:", error);
            mode = "button";
        }
    }
    if (window.Calendly && mode === "inline") {
        window.Calendly.initInlineWidget({
            parentElement: calendlyElement,
            url
        });
    }
});
const openPopUp = (url2) => {
    if (window.Calendly) {
        window.Calendly.initPopupWidget({ url: url2 });
    }
};
</script>

<svelte:head>
    {#if mode === 'popup'}
        <link href = 'https://assets.calendly.com/assets/external/widget.css' rel = 'stylesheet'>
    {/if}
</svelte:head>

{#if mode === 'popup'}
        <Button
            on:click = { openPopUp.bind(null, url) }
            { icon }
            { label }
            { css }
            color = 'dark'
        />
{/if}

{#if mode === 'inline'}
    <div
        bind:this = { calendlyElement }
        class = 's8-calendly-inline'
        style = { css }
    />
{/if}

{#if mode === 'button'}
        <Button
            label='Book a Calendly Appointment'
            { icon }
            { url }
            { css }
            color = 'dark'
        />
{/if}

<style>

    .s8-calendly-inline {
        min-width: 320px;
        height:1150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }</style>